<template>
  <div>
    <div
      v-for="item of items" 
      :key="item.id" 
      class="radio-buttons-container d-flex align-items-center py-2"
      @click.stop="select(item.id)"
    >
      <div
        class="item d-flex align-items-center"
        :class="{ 'disabled' : !item.available }"
      >
        <div 
          class="icon-container d-flex align-items-center justify-content-center me-2 rounded-circle" 
          :class="{
            checked: item.id === selectedItem,
          }"
        >
          <i class="icon fa fa-check" />
        </div>
        <div>
          {{ displayedLabel(item) }}
        </div>
      </div>

      <div class="spacer" />

      <div v-if="useComboButton && item.id === selectedItem">
        <button-combo-next
          :clicked="clickedForwardButton"
          :price="item.price"
        />
      </div>

      <div 
        v-else 
        class="me-1 fw-bold"
      >
        <Price :amount="item.price" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import ButtonComboNext from './ButtonComboNext.vue';
import Price from './Price.vue';

export default {
  name: 'RadioButtons',
  components: { Price, ButtonComboNext },

  props: {
    items: { type: Array as PropType<any[]>, default: undefined },
    selectedItem: { type: String, default: ''},
    useComboButton: { type: Boolean, default: false },
    select: { type: Function, default: () => console.log('select Not implemented')}, // eslint-disable-line no-console
    displayedLabel: { type: Function, default: () => console.log('displayedLabel Not implemented')}, // eslint-disable-line no-console
    clickedForward: { type: Function, default: () => console.log('clickedForward Not implemented')}, // eslint-disable-line no-console
  },

  methods: {
    clickedForwardButton() {
      this.clickedForward(this.category)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.radio-buttons-container {
  border-bottom: 1px solid $color-expinet-gray;
  height: 49px;
}

.item {
  &:not(.disabled):hover {
    cursor: pointer;

    .icon-container {
      border: 2px solid $color-expinet-blue;
    }
  }

  &.disabled {
    color: $color-expinet-gray;
  }
}

.icon-container {
  width: 20px;
  height: 20px;
  border: 2px solid $color-expinet-dark-gray;
  color: $color-expinet-dark-gray;

  .icon {
    display: none
  }

  &.checked {
    color: $color-aida-white;
    border: 2px solid $color-expinet-blue;
    background-color: $color-expinet-blue;
  
    .icon {
      display: initial;
    }
  }
}

.spacer {
  flex: 1;
}
</style>
